import { ForwardedRef, forwardRef, useState } from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import { IdValue } from "components/Shared/Select/useIdValue";
import CreateOrderingPlatformModal from "components/Shared/OrderingPlatformDirectory/CreateModal";
import {
  Option,
  OrderingPlatformSelectInstance,
  OrderingPlatformSelectProps,
  useOrderingPlatformSelect,
} from "./OrderingPlatformSelect";

function CreatableOrderingPlatformSelectInner<IsMulti extends boolean = false>(
  props: OrderingPlatformSelectProps<IsMulti>,
  ref: ForwardedRef<OrderingPlatformSelectInstance<IsMulti>>,
) {
  const { isAdmin, isMulti, value, onChange } = props;
  const selectProps = useOrderingPlatformSelect<IsMulti>(props);

  const [createOrderingPlatformName, setCreateOrderingPlatformName] = useState<
    string | null
  >(null);

  return (
    <>
      <AsyncCreatableSelect<Option, IsMulti>
        ref={ref}
        {...selectProps}
        formatCreateLabel={(inputValue) => `Create customer: “${inputValue}”`}
        isValidNewOption={(inputValue) => inputValue.length > 1}
        onCreateOption={(inputValue) =>
          setCreateOrderingPlatformName(inputValue)
        }
      />

      <CreateOrderingPlatformModal
        defaultValues={{ name: createOrderingPlatformName }}
        isAdmin={isAdmin}
        isOpen={!!createOrderingPlatformName}
        onClose={() => setCreateOrderingPlatformName(null)}
        onCompleted={(id) => {
          setCreateOrderingPlatformName(null);
          onChange?.(
            (isMulti ? [...(value as string[]), id] : id) as IdValue<
              IsMulti,
              string
            >,
          );
        }}
      />
    </>
  );
}

export default forwardRef(CreatableOrderingPlatformSelectInner);
